import http from '@http';

class IntegrationService {
    constructor() {
        if (IntegrationService.instance) {
            return IntegrationService.instance;
        }
        IntegrationService.instance = this;
    }

    getIntegrations() {
        return http.get('/api/admin/integrations').then(res => res.data);
    }

    getIntegrationModules() {
        return http.get('/api/admin/integration-modules').then(res => res.data);
    }

    getIntegrationModule(id) {
        return http.get(`/api/admin/integration-modules/${id}`).then(res => res.data);
    }

    getIntegrationModuleClients(moduleId, queryObj) {
        return http.get(`/api/admin/integration-modules/${moduleId}/clients`, {params: queryObj}).then(res => res.data);
    }

    addModule(data) {
        return http.post('/api/admin/integration-modules', data).then(res => res.data);
    }

    updateIntegrationModule(moduleId, data) {
        return http.put(`/api/admin/integration-modules/${moduleId}`, data).then(res => res.data);
    }

    addIntegration(data) {
        return http.post('/api/admin/integrations', data).then(res => res.data);
    }

    getIntegration(id) {
        return http.get(`/api/admin/integrations/${id}`).then(res => res.data);
    }

    updateIntegrationSettings(id, settings) {
        return http.put(`/api/admin/integrations/${id}`, settings).then(res => res.data);
    }

    addIntegrationClient(integrationId, data) {
        return http.post(`/api/admin/integrations/${integrationId}/clients`, data).then(res => res.data);
    }

    addIntegrationModuleClient(moduleId, data) {
        return http.post(`/api/admin/integration-modules/${moduleId}/clients`, data).then(res => res.data);
    }

    updateIntegrationClient(clientId, data) {
        return http.put(`/api/admin/integrations/client/${clientId}`, data).then(res => res.data);
    }

    updateIntegrationModuleClient(clientId, data) {
        return http.put(`/api/admin/integration-modules/client/${clientId}`, data).then(res => res.data);
    }

    getIntegrationClients(integrationId, queryObj) {
        return http.get(`/api/admin/integrations/${integrationId}/clients`, {params: queryObj}).then(res => res.data);
    }

    deleteIntegrationClient(integrationId) {
        return http.delete(`/api/admin/integrations/client/${integrationId}`).then(res => res.data);
    }

    deleteIntegrationModuleClient(clientId) {
        return http.delete(`/api/admin/integration-modules/client/${clientId}`).then(res => res.data);
    }

    getIntegrationPartners() {
        return http.get('/api/admin/integrations/partners').then(res => res.data);
    }

    addIntegrationPartner(data) {
        return http.post('/api/admin/integrations/partners', data).then(res => res.data);
    }

    updateIntegrationPartner(partnerId, data) {
        return http.put(`/api/admin/integrations/partners/${partnerId}`, data).then(res => res.data);
    }

    getKindergartenChildImportIntegrations(kindergartenId) {
        return http.get(`/api/kindergartens/${kindergartenId}/child-import-integrations`).then(res => res.data);
    }
    getKindergartenIntegrations(kindergartenId) {
        return http.get(`/api/kindergartens/${kindergartenId}/integrations`).then(res => res.data);
    }
}

export default new IntegrationService();
